const Button = ({ className, type, onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className={`py-2 px-4 flex items-center gap-2 rounded-lg ${className}`}
      type={type || "submit"}
    >
      {children}
    </button>
  );
};

export default Button;
